/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desc_Receipt_InfoInputs */

const en_desc_receipt_info = /** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appears on buyer receipts and invoices.`)
};

const es_desc_receipt_info = /** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparece en los recibos y facturas de los compradores.`)
};

const fr_desc_receipt_info = /** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaît sur les reçus et factures des acheteurs.`)
};

const de_desc_receipt_info = /** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erscheint auf den Quittungen und Rechnungen der Käufer.`)
};

const id_desc_receipt_info = /** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muncul pada tanda terima dan faktur pembeli.`)
};

/** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */
const ja_desc_receipt_info = en_desc_receipt_info;

/** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */
const zh_desc_receipt_info = en_desc_receipt_info;

/** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */
const ar_desc_receipt_info = en_desc_receipt_info;

/** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */
const it_desc_receipt_info = en_desc_receipt_info;

/** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */
const ru_desc_receipt_info = en_desc_receipt_info;

/** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */
const pt_desc_receipt_info = en_desc_receipt_info;

/** @type {(inputs: Desc_Receipt_InfoInputs) => LocalizedString} */
const ko_desc_receipt_info = en_desc_receipt_info;

/**
* | output |
* | --- |
* | "Appears on buyer receipts and invoices." |
*
* @param {Desc_Receipt_InfoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const desc_receipt_info = /** @type {((inputs?: Desc_Receipt_InfoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desc_Receipt_InfoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_desc_receipt_info(inputs)
	if (locale === "es") return es_desc_receipt_info(inputs)
	if (locale === "fr") return fr_desc_receipt_info(inputs)
	if (locale === "de") return de_desc_receipt_info(inputs)
	if (locale === "ja") return ja_desc_receipt_info(inputs)
	if (locale === "zh") return zh_desc_receipt_info(inputs)
	if (locale === "ar") return ar_desc_receipt_info(inputs)
	if (locale === "id") return id_desc_receipt_info(inputs)
	if (locale === "it") return it_desc_receipt_info(inputs)
	if (locale === "ru") return ru_desc_receipt_info(inputs)
	if (locale === "pt") return pt_desc_receipt_info(inputs)
	return ko_desc_receipt_info(inputs)
});